import Payment from "../components/inventory/buy/payment";
import Nav from "../components/inventory/vendor/navbar";
const ListingPage = () => {
  return (
    <div>
      <Nav />
      <Payment />
    </div>
  );
};

export default ListingPage;